<template>
  <div class="fixed-height-450">
    <div v-if="myRecentNotifications.length">
      <table class="padding-top-20 border-collapse width-100">
        <tbody>
          <tr 
            v-for="(notification, index) in myRecentNotifications" 
            :key="notification._id || index"
            :class="notification.isClicked ? 'bg-light-grey' : 'bg-white'" 
            class="border-color-light-grey border-1"
          >
            <td 
              class="d-flex padding-10 cursor-pointer" 
              @click="handleNotificationClick(notification)"
            >
              <i class="fa fa-bell font-size-12 logo-blue avatar-initials bg-light-grey min-width-25 max-width-25 fixed-height-25 margin-right-10"></i>
              <div>
                <div class="font-size-14">
                  {{ notification.message }}
                </div>
                <span class="grey font-size-12">
                  {{ toGetRelativeTime(notification.createdAt) }}
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="isMore" class="padding-10 text-center">
        <span class="cursor-pointer logo-blue" @click="$router.push('/notifications')">
          See all notifications
        </span>
      </div>
    </div>
    <div v-else class="d-flex align-items-center justify-content-center fixed-height-450">
      <p class="grey">
        There are no recent notifications
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { toGetRelativeTime } from "../../../utility";

export default {
  name: "RecentNotifications",
  emits: ['close'],
  setup() {
    return { toGetRelativeTime };
  },
  data() {
    return {
      myRecentNotifications: [],
      limit: 5,
      isMore: false,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
    }),
  },
  methods: {
    loadRecentNotifications() {
      this.$socket.emit("GET_NOTIFICATIONS", { limit: this.limit });
    },
    handleNotificationClick(notification) {
      this.markNotificationAsClicked(notification._id);
      if (notification.actionPath) {
        this.$router.push(notification.actionPath);
        this.$emit('close');
      }
    },
    markNotificationAsClicked(notificationId) {
      this.$socket.emit("MARK_NOTIFICATION_AS_CLICKED", notificationId);

      this.myRecentNotifications = this.myRecentNotifications.map((item) => {
        if (item._id == notificationId) {
          item.isClicked = true;
        }
        return item;
      });
    },
  },
  mounted() {
    this.loadRecentNotifications();
    this.$socket.on("NOTIFICATIONS", (data) => {
      // Logic for showing 'See more'
      this.isMore = data.length >= this.limit;
      this.myRecentNotifications = data;
    });
  },
  beforeUnmount() {
    // 2026 Best Practice: Cleanup socket listener
    this.$socket.off("NOTIFICATIONS");
  }
};
</script>

<style scoped>
.width-100 {
  width: 100%;
}
.font-size-14 {
  font-size: 14px;
}
.text-center {
  text-align: center;
}
</style>
